import { matchPath } from 'react-router';

import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import { navigateToAppointments } from 'actions/navigateActions';
import { FETCH_DEALER_FAILURE, FETCH_DEALER_SUCCESS } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';

import * as actions from 'modules/appointments/actions';
import * as detailsActions from 'modules/appointments/actions/details';
import * as actionTypes from 'modules/appointments/actionTypes';

import { getSelectedId } from 'modules/appointments/selectors/details';
import * as tasksTypes from 'modules/appointmentTask/actionTypes';
import { selectDealer } from 'modules/dealers/actions';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { getCurrentLocation } from 'selectors/router';

function* fetchAppointmentSuccess({ payload: appointment, meta }) {
  yield put(selectDealer(appointment.dealer?.id));
  yield take([FETCH_DEALER_SUCCESS, FETCH_DEALER_FAILURE]);

  yield put(detailsActions.applicationIsReady());
  const haveUnreadMessage = appointment.intervention?.conversationContext?.unreadCount > 0;
  if (meta.readMessages && haveUnreadMessage) {
    yield put(detailsActions.readMessages(appointment.id));
  }
}

function* fetchEventsAfterLockerAction() {
  const id = yield select(getSelectedId);
  yield put(detailsActions.fetchEvents(id));
}

function* redirectToDashboard() {
  yield call(navigateToAppointments);
}

/** Action patters  */
const redirectAfterPatchStatus = ({ type, meta }) =>
  type === actionTypes.PATCH_STATUS_SUCCESS && meta.redirectToDashboard;

function* onAppointmentDetailsPageWorker() {
  const location = yield select(getCurrentLocation);
  const match = matchPath(PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED, location);

  yield put(actions.fetchAppointment(match.params.appointmentId, { readMessages: true }));

  yield takeLatest(redirectAfterPatchStatus, redirectToDashboard);
  yield takeLatest(actionTypes.DELETE_SUCCESS, redirectToDashboard);
  yield takeLatest(actionTypes.FETCH_APPOINTMENT_SUCCESS, fetchAppointmentSuccess);
  yield takeLatest(
    [tasksTypes.POST_VERIFY_SUCCESS, tasksTypes.POST_PREPARE_SUCCESS, tasksTypes.POST_UNPREPARE_SUCCESS],
    fetchEventsAfterLockerAction
  );
}

/**
 * Custom channel pattern
 *   In the case of the locker should be prepared, we use `navigate` with the option 'force replace' to update selected tab
 *   So to avoid retriggering the saga, the location change action should not be a "REPLACE" action
 * @param {import('modules/global/generic.types').Action} param0
 * @returns {boolean}
 */
const channelPattern = ({ type, payload }) => type === LOCATION_CHANGE && payload.action !== 'REPLACE';

export default function* appointmentDetailsSagas() {
  yield scopeToPage(
    [PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED],
    onAppointmentDetailsPageWorker,
    undefined,
    channelPattern
  );
}
